import CurrencyFormatter from "currency-formatter";

export default class ForecastReasonableCompensation {
  constructor({
    salary = 0,
    benefitsPercentage = 0,
    onePlusGrowthRate = 0,
    analystNote = ""
  }) {
    this.salary = salary
    this.benefitsPercentage = benefitsPercentage
    this.onePlusGrowthRate = onePlusGrowthRate
    this.analystNote = analystNote
  }


  get reasonableCompensationEstimate() {
    return this.salary * (1 + (this.benefitsPercentage / 100))
  }

  get reasonableCompensationEstimateFormatted() {
    return CurrencyFormatter.format(this.reasonableCompensationEstimate, { code: "USD", symbol: "" })
  }

  get forecastedReasonableCompensation() {
    return this.reasonableCompensationEstimate * (this.onePlusGrowthRate )
  }

  get forecastedReasonableCompensationFormatted() {
    return CurrencyFormatter.format(this.forecastedReasonableCompensation, { code: "USD", symbol: "" })
  }
}